export const info = {
  contractAddress: "0xB2EAE48bDcEa68615e1C398598bE552b1aD40F37",
  stakingTokenSymbol: "TEST",
  rewardTokenSymbol: "TEST",
  stakingTokenDecimal: 18,
  rewardTokenDecimal: 18,
  stakingTokenAddress: "0x3c7866633A45535B7fBb1b1Cc6B42A87232633Da",
  rewardTokenAddress: "0x3c7866633A45535B7fBb1b1Cc6B42A87232633Da",
};
